import { type PreParsedSectionItemsLinkProps, type PreParsedSectionLinkProps } from '@capsicum/common';

const helpItems: Array<PreParsedSectionItemsLinkProps> = [
	{
		configServiceParam: 'faqsLink',
		isTrailingIconReversible: true,
		testID: 'faqs-link',
		title: 'more.faqs',
		trailingIcon: 'ChevronRightIcon',
		webView: false
	}
];

const helpSection: PreParsedSectionLinkProps = {
	items: helpItems,
	title: 'profile.help'
};

const quickLinksItems: Array<PreParsedSectionItemsLinkProps> = [
	{
		configServiceParam: 'stakeAndEarnLink',
		isTrailingIconReversible: true,
		testID: 'stake-and-earn-link',
		title: 'profile.quickLinks.stakeAndEarn',
		trailingIcon: 'ChevronRightIcon',
		webView: true
	},
	{
		configServiceParam: 'sociosWalletLink',
		isTrailingIconReversible: true,
		testID: 'socios-wallet-link',
		title: 'profile.quickLinks.sociosWallet',
		trailingIcon: 'ChevronRightIcon',
		webView: true
	},
	{
		configServiceParam: 'fanRewardsLink',
		isTrailingIconReversible: true,
		testID: 'fan-rewards-link',
		title: 'profile.quickLinks.fanRewards',
		trailingIcon: 'ChevronRightIcon',
		webView: true
	},
	{
		configServiceParam: 'withdrawalsAndTradingLink',
		isTrailingIconReversible: true,
		testID: 'withdrawals-and-trading-link',
		title: 'profile.quickLinks.withdrawalsAndTrading',
		trailingIcon: 'ChevronRightIcon',
		webView: true
	}
];

const quickLinksSection: PreParsedSectionLinkProps = {
	items: quickLinksItems,
	title: 'profile.quickLinks.title'
};

const contactItems: Array<PreParsedSectionItemsLinkProps> = [
	{
		configServiceParam: 'contactUsHereLink',
		isTrailingIconReversible: true,
		testID: 'contact-us-here-link',
		title: 'profile.contactUsHere',
		trailingIcon: 'ChevronRightIcon',
		webView: true
	}
];

const contactSection: PreParsedSectionLinkProps = {
	items: contactItems,
	title: 'profile.support'
};

export const supportSections = [helpSection, quickLinksSection, contactSection];
